module.exports = __webpack_public_path__ + "static/WEDDING E&M-552-52ad74a9db0312853d921620f0929d4a.jpg";